var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystoreicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7087 20.417C24.2692 18.4185 26.9683 16.8956 27.201 16.7772C27.9452 16.3726 28.7138 15.3017 27.201 14.4699C26.7125 14.2083 24.0827 12.7329 20.7087 10.8301L16.0312 15.6591L20.7087 20.4169V20.417Z",
    fill: "#FFD900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.034 15.6602L1.14062 31.0048C1.49021 31.0521 1.88487 30.9573 2.35018 30.6958C3.32708 30.1492 13.6831 24.3677 20.7114 20.4192L16.034 15.6602Z",
    fill: "#F43249"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0337 15.6593L20.7111 10.8541C20.7111 10.8541 3.39742 1.19476 2.34988 0.624556C1.95522 0.3856 1.51295 0.314619 1.11719 0.3856L16.0337 15.6593Z",
    fill: "#00EE76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0335 15.6584L1.11697 0.384766C0.511594 0.527848 0 1.07461 0 2.1928V29.195C0 30.2185 0.395871 30.9557 1.14012 31.0267L16.0335 15.6584Z",
    fill: "#00D3FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreicon);
export default __webpack_public_path__ + "static/media/playstoreicon.623d4ddf7d058a2b5de8d06fe7128f09.svg";
export { ForwardRef as ReactComponent };